<template>
    <div>
        <b-modal
            id="overwrite-result-popup"
            title="Manually Overwrite Result"
            size="sm"
            cancel-title="Cancel"
            cancel-variant="link"
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            :ok-disabled="loading"
            :cancel-disabled="loading"
            @ok.prevent="ok"
            @shown="initializeData"
        >
            <p>
                Are you sure you want to manually overwrite liveness detection
                result?
            </p>
            <b-form>
                <b-form-group
                    class="kyc-status-radio overwrite-radio"
                    label="MANUALLY OVERWRITE RESULT"
                    label-for="results"
                >
                    <b-form-group>
                        <b-form-radio-group
                            v-model="result"
                            v-validate="{
                                required: true,
                            }"
                            :options="options[verificationType]"
                            data-vv-name="overwrite result"
                            :class="{
                                'is-invalid': errors.has('overwrite result'),
                            }"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-form-group>
            </b-form>

            <template v-slot:modal-ok>
                <span class="btn-text">Submit</span>
                <span class="loader"></span>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import request from '@/utils/request'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        customerId: {
            required: true,
        },
        verificationType: {
            type: String,
            in: ['liveness', 'face'],
            default: 'liveness',
        },
        customerDetails: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            result: null,
            options: {
                liveness: [
                    {
                        text: 'Fake',
                        value: 'Fake',
                    },
                    {
                        text: 'Real',
                        value: 'Real',
                    },
                ],
                face: [
                    {
                        text: 'Matched',
                        value: 'Matched',
                    },
                    {
                        text: 'Not Matched',
                        value: 'Not Matched',
                    },
                ],
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'alertRecord']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async ok() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)
                try {
                    const { data } = await request.put(
                        `customers/manually-overwrite/${this.customerId}`,
                        {
                            verificationType: this.verificationType,
                            result: this.result,
                            alertId: this.alertRecord._id,
                        }
                    )

                    this.$emit('customer', data.data)

                    setTimeout(
                        function () {
                            this.$bvModal.hide('overwrite-result-popup')
                            this.$store.commit('setLoading', false)
                            this.$store.commit(
                                'setSuccess',
                                'Result has been manually overwritten successfully.'
                            )
                        }.bind(this),
                        1000
                    )
                    let alert = JSON.parse(JSON.stringify(this.alertRecord))
                    alert.canCancelReview = false
                    this.$store.commit('setAlertRecord', alert)
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    console.log(error)
                }
            } else {
                this.$store.commit('setError', 'Please select one option.')
            }
        }, // End of ok() method
        async initializeData() {
            this.result =
                this.customerDetails.verificationStatus[
                    this.verificationType
                ].result
        },
    }, // End of Component > methods
} // End of export default
</script>
